import { css } from 'lit';

export const projectManageViewStyles = css`

  /*=== BASE LAYOUT ===*/

  view-content {
    padding-top: 6rem;
    position: relative;
  }

  /*=== PROJECT HEADER ===*/

  project-header {
    display: block;
    position: relative;
    margin-bottom: 1rem;

    max-width: var(--q1-view-width);
    margin-left: auto !important;
    margin-right: auto !important;
  }

  project-header-content {
    display: flex;
    position: relative;
    gap: 1rem;
    align-items: center;
  }
  @media (min-width: 650px) {
    project-header-content {
      gap: 1.5rem;
    }
  }

  sl-avatar#project-avatar {
    --size: 4rem;
  }
  sl-avatar#project-avatar::part(base) {
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  header-bar {
    margin: 0 !important;
  }
  header-bar .prefix {
    font-size: 1rem;
  }

  sl-breadcrumb-item:not(:last-of-type)::part(label) {
    color: var(--theme-color-primary-6);
  }

  h1 {
    font-size: 1.3rem;
    line-height: 1.2em;
    font-weight: 300;
    margin: 0;
  }
  @media (min-width: 650px) {
    h1 {
      font-size: 1.5rem;
    }
  }

  q1-alert-bar#activation-bar {
    max-width: var(--q1-view-width);
    margin: -1rem auto var(--view-item-spacing) auto;
  }

  /*=== TAB CONTENT ===*/

  h3 {
    margin-bottom: var(--view-item-spacing);
  }

  .form-footer {
    margin: 2.5rem 0;
    font-style: italic;
  }

  /*=== PROJECT DETAILS ===*/

  q1-md-textarea {
    --label-width: 12rem;
    margin-bottom: 1.5rem;
  }

  /*=== THEME BUILDER ===*/

  q1-project-card#project-card-preview::part(base) {
    padding: 5rem;
  }

  /*=== SETTINGS TAB ===*/

  .project-settings sl-radio-group.label-on-left {
    --label-width: 12rem;
  }

  #settings-form h3 {
    margin-top: 3.5rem;
  }

  sl-radio-button sl-icon.faux-prefix {
    position: relative;
    left: -8px;
    margin-left: 8px;
  }

  /*=== UTILITY TABLE ===*/

  table.utility-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: none;

    /* Note: Borders are applied on cells not table */
    --table-border-radius: 7px;
    --table-border-width: 1px;
    --table-border-style: solid;
    --table-outer-border-color: var(--gray-3);
    --table-inner-border-color: var(--gray-2);

    --table-cell-padding: var(--sl-spacing-medium);
    
    --table-th-bg-color: var(--gray-3);
    --table-th-color: var(--gray-9);
    --table-th-font-size: var(--sl-font-size-medium);
    --table-th-font-weight: var(--sl-font-weight-semibold);
    
    --table-td-bg-color: var(--gray-0);
    --table-td-bg-stripe-color: var(--gray-1);
    --table-td-bg-focus-color: var(--yellow-0);
    --table-td-color: var(--gray-7);
    --table-td-font-size: var(--sl-font-size-medium);
    --table-td-font-weight: var(--sl-font-weight-normal);

    --table-outer-border:
      var(--table-border-width) var(--table-border-style) var(--table-outer-border-color);
    --table-inner-border:
      var(--table-border-width) var(--table-border-style) var(--table-inner-border-color);
  }

  table.utility-table tr:first-child td:first-child {
    border-top-left-radius: var(--table-border-radius);
  }
  table.utility-table tr:first-child td:last-child {
    border-top-right-radius: var(--table-border-radius);
  }
  table.utility-table tr:last-child td:first-child {
    border-bottom-left-radius: var(--table-border-radius);
  }
  table.utility-table tr:last-child td:last-child {
    border-bottom-right-radius: var(--table-border-radius);
  }

  table.utility-table th:first-child,
  table.utility-table td:first-child {
    border-left: var(--table-outer-border);
  }
  table.utility-table th:last-child,
  table.utility-table td:last-child {
    border-right: var(--table-outer-border);
  }

  table.utility-table td {  
    padding: var(--table-cell-padding);
    border-bottom: var(--table-inner-border);

    background-color: var(--table-td-bg-color);
    color: var(--table-td-color);
    font-size: var(--table-td-font-size);
    font-weight: var(--table-td-font-weight);

    transition: all 0.2s ease-in-out;
  }

  table.utility-table td.align-right {
    text-align: right;
  }
  table.utility-table td.align-left {
    text-align: left;
  }
  table.utility-table td.align-center {
    text-align: center;
  }

  table.utility-table td.align-right q1-member-chip::part(base) {
    justify-content: flex-end;
  }

`;
